module.exports = __webpack_public_path__ + "static/media/Ciruclaruppms2019-20.b8036f47.pdf";